runOnLoad "SuppressedAddressImports", ["new", "create"], ->
  FileUploadSelection.setup "suppressed_address_import"
  SchedulableForm.setup "suppressed_address_import"